import React, { Component, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import { Link } from 'react-router-dom';
import Helper from '../Helper';
import { APPLICATION_JSON, SET_CHECKOUT_HEADER_OPTIONS } from '../../middleware/types';
import { checkOutHeaderOptionsAction } from '../../middleware/CheckOutHeaderOptionsAction';
import { useDispatch, useSelector } from 'react-redux';

export const Redeem = ({ containerObject, templateName, contentId, dataZone }) => {
    const [redeemDetails, setRedeemDetails, redeemDetailsRef] = useStateRef('')
    const [inputFields, setInputFields, inputFieldsRef] = useStateRef(1);
    const [uploadDocHtmlData, setUploadDocHtmlData] = useState([]);
    const [duplicateInputs, setDuplicateInputs ] = useState([]);
    const [deliveryShow, setDeliveryShow, deliveryShowRef] = useStateRef(true);
    const [isDlType, setIsDlType, isDlTypeRef] = useStateRef(false);
    const [search,setSearch, searchRef] = useStateRef('');
    const [voucherIds, setVoucherIds, voucherIdsRef] = useStateRef([]);
    const [replaceMsg, setReplaceMsg, replaceMsgRef] = useStateRef('');
    const history = useHistory();
    const dispatch = useDispatch();
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    
        useEffect(()=>{
            if (loaderStatus == true) {
                console.log("log in redeemShipping page loader true");
            } else {
                console.log("log in redeemShipping page loader false");
            setSearch(window.location.pathname)
            if(searchRef.current && searchRef.current.includes('/voucher/redeem')){
                const queryParams = new URLSearchParams(window.location.search)
                const vType = queryParams.get("vType")
                if(vType == 'dl'){
                    setIsDlType(true);
                    dispatch(checkOutHeaderOptionsAction(false)); 
                    getRedeemDetails()   
                }else{
                    getVoucherType();
                }
            }
            }
        },[])

        async function getRedeemDetails(){
       
        var actionUrl = "/api/rest/cb/redeem/get-redeem-details";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}?isDlType=${isDlTypeRef.current}`
        
        var res = await Helper.fetchCallFunction(url, "GET", false, APPLICATION_JSON,'' )
        var response = (JSON.parse(res.response)).response;
        if (res.response != null) {
            setRedeemDetails(response['response'] && response['response']);
            setVoucherIds(redeemDetailsRef?.current?.voucherIds);
            if(voucherIdsRef.current?.length ==1){
                const voucherId = voucherIdsRef.current[0];
                if(voucherId.trim()){
                    document.getElementById("number" + 1).value = voucherId;
                }else{
                    document.getElementById("number" + 1).value = voucherId.trim();
                }
            }
            else if(voucherIdsRef.current?.length >1) {
                setInputFields(voucherIdsRef.current.length-1);
                await  handleAddField();
                populateMultipleVoucherField();
            } 
            var TextInsideP = document.getElementById('instruction-msg').innerText;
          
            if( screen.width < 428){
                const regex = /^1-\d{3}-\d{3}-\d{4}$/
               const splittedWords = TextInsideP.split(' ');
               var phoneNumber ='';
               splittedWords.forEach((word)=>{
                if (word.match(regex)) {
                  
                     phoneNumber = word.match(regex)[0];
                }
               })
            
                TextInsideP = TextInsideP.replace(phoneNumber, `<a href="tel:+${phoneNumber}">${phoneNumber}</a>`)
                setReplaceMsg(TextInsideP);
               
            }else{
                setReplaceMsg('');
            }
          
        }
        }

        async function getVoucherType(){
            var actionUrl = "/api/rest/cb/redeem/get-voucher-type";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            
            var res = await Helper.fetchCallFunction(url, "GET", false, APPLICATION_JSON,'' )
            var response = (JSON.parse(res.response)).response;
            if (res.response != null) {
                if(response?.isDLContains === true){
                    setIsDlType(true);
                    dispatch(checkOutHeaderOptionsAction(false));
                    getRedeemDetails()
                }else{
                    setIsDlType(false)
                    dispatch(checkOutHeaderOptionsAction(true));
                    getRedeemDetails()
                }
            }
            else{
                console.log('res.response..',res.response);
            }
        }
        const populateMultipleVoucherField = ()=>{
            voucherIdsRef?.current?.map((voucherId, index)=>{   
                if(document.getElementById("number" + (index+1))){
                    if(voucherId.trim()){
                        document.getElementById("number" + (index+1)).value = voucherId;
                    }else{
                        document.getElementById("number" + (index+1)).value = voucherId.trim();
                    }
                    
                }               
            })           
        }
        
    const handleAddField = () => {
        setInputFields(inputFieldsRef.current + 1);
        var elements = [];
        if (inputFieldsRef.current >= 20) {
            document.getElementById("addCode").classList.remove("d-block");
            document.getElementById("addCode").classList.add("d-none");
            document.getElementById("addMessage").classList.remove("d-none");
            document.getElementById("addMessage").classList.add("d-block");
        }
        for (var i = 2; i <= inputFieldsRef.current; i++) {
            elements.push(              
                <div class="row g-0 g-md-2 mb-3">
                    <div class="col-md-6 col-lg-4">
                        <label for="code" class="form-label">Code</label>
                        <input name={"redeemCode" + i}  id={"number" + i} type="text" class="form-control" onChange={handleChange}/>
                    </div>
                </div>
            )
        }
        setUploadDocHtmlData(elements)
    };
    
    const clearErrorMsg = () => {
        for (var i = 1; i <= inputFieldsRef.current; i++) {
            document.getElementById("number"+i).classList.remove("form-error");
        }
    }

    async function handleSubmit(event) {
        event.preventDefault();
        clearErrorMsg();
        

        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        let inputString= "";
        let size=0;
        for (var i = 1; i <= inputFieldsRef.current; i++) {
            let redeemCode = formData.get("redeemCode"+i);
            if(!voucherIdsRef.current.includes(redeemCode)){
                voucherIdsRef.current.push(redeemCode);

            }
    //        if(redeemCode.length !== 0 ){
                if(inputString.includes(redeemCode)){
                    duplicateInputs.push("number"+i);
                    setDuplicateInputs(duplicateInputs);
                }
                if(redeemCode){
                    inputString = inputString+"number"+i +":"+redeemCode;
                }else{
                    inputString = inputString+"number"+i +":"+" ";
                }
                if(i<inputFieldsRef.current){
                    inputString = inputString+",";
                }
                
     //       }
            size++;
        }

        var actionUrl = "api/rest/cb/redeem/redeem-voucher/apply";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            codeList: inputString,
            size: size,
            successURL: "/voucher/shipping",
            failureURL:"/voucher/redeem",
            validateVouchers: "ContinuetoShipping"
        }))
        const response = JSON.parse(res.response);
        if (res.result === "success" && response.status === "success"){
          
            if(response.response && response.response['deliveryShow' ] === true || response.response['deliveryShow' ] === false){
                dispatch(checkOutHeaderOptionsAction(response.response['deliveryShow']));
                history.push("/voucher/shipping");
            }
            
        } else {
            const responseObj = JSON.parse(res.response);
            if(inputString !== ""){
                if(responseObj?.response?.isDLContains === true ){
                    setIsDlType(responseObj?.response?.isDLContains);
                    dispatch(checkOutHeaderOptionsAction(false));
                    getRedeemDetails();
                }else if(responseObj?.response?.isDLContains === false){
                    setIsDlType(false);
                    dispatch(checkOutHeaderOptionsAction(true));
                    getRedeemDetails();
                }else{
                    console.log('response????',responseObj?.response);
                    console.log('isDLContains is empty...');
                }
            }
            var invalidVouchers = responseObj?.response?.invalidvoucherList;
         if(voucherIdsRef.current){
             voucherIdsRef.current.map((voucherId,index)=>{
                 if(invalidVouchers.includes("number"+(index+1))){
                     document.getElementById("number"+(index+1)) && document.getElementById("number"+(index+1)).classList.add("form-error");
                 }else{  
                     document.getElementById("number"+(index+1)) && document.getElementById("number"+(index+1)).classList.remove("form-error");
                 }
             })
         }
            const errorMessage = responseObj.errorMessage;
            let message ;
            errorMessage.map((obj)=>{
                if(obj?.message){
                   message = obj.message;
                }
            })

            if(message !== null){
                document.getElementById("errMsgAlert").classList.remove("d-none");
                document.getElementById("errMsgAlert").classList.add("d-block");
                document.getElementById("errMsgAlert").innerHTML=message ;
                if(duplicateInputs && duplicateInputs.length > 0 && message.includes("duplicate vouchers and use only once")){
                    duplicateInputs.forEach(duplicateInput => {
                        document.getElementById(duplicateInput).classList.add("form-error");
                    })
                }
              
                const element = document.getElementById('errMsgAlert');
                if (element) {
             
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop = elementRect.top + window.pageYOffset;
                    const middle = absoluteElementTop - (window.innerHeight / 2);
                    var i = 10;
                    var int = setInterval(function() {
                      window.scrollTo(0, i);
                      i += 20;
                      if (i >= middle) clearInterval(int);
                    }, 20);
                }
            }else{
                console.log("responseObj + " , responseObj);
            }
        }
    }

    const handleChange = (e)=>{
        if(duplicateInputs && duplicateInputs.length > 0){
            duplicateInputs.forEach(duplicateInput => {
                if(e.target.id === duplicateInput){
                    document.getElementById(duplicateInput).classList.remove("form-error");
                    setDuplicateInputs(duplicateInputs.filter(di=>di!==duplicateInput));
                }
            })
        } 
    }

    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
        <div className="row justify-content-center c-account-page c-school-page c-steps-page">
            <div class="col-11 col-md-11 my-5 c-steps-pd">
                <div class="row">

                    <div class="col-md-12 text-left mb-3">
                        {isDlTypeRef.current &&
                             <p class="c-account-heading mb-4">
                                 {redeemDetailsRef.current && redeemDetailsRef.current.welcomeMsg ? redeemDetailsRef.current.welcomeMsg:''}                       
                             </p>
                        }
                        <h1 class="c-account-heading mb-2">
                           {redeemDetailsRef.current && redeemDetailsRef.current.headingMsg? redeemDetailsRef.current.headingMsg:''}
                        </h1>
                        <p id='instruction-msg' class="c-regular-text" dangerouslySetInnerHTML={{__html: replaceMsgRef.current ? replaceMsgRef.current: redeemDetailsRef.current?.instructionMsg ? redeemDetailsRef.current.instructionMsg :''}}>
                            {/* {redeemDetailsRef.current && redeemDetailsRef.current?.instructionMsg ? redeemDetailsRef.current.instructionMsg :''} */}
                            
                        </p>
                    </div>


                </div>

                <div id="dynamicHTML">

                    <div class="alert alert-danger d-none" id="errMsgAlert" role="alert">
                    </div>
                    <form method="post" class="" data-hs-cf-bound="true" onSubmit={handleSubmit}>
                        <div class="row g-0 g-md-5 px-md-4 pt-4">
                            <div class="col-12 col-md-12">
                                <div class="test cv-field">
                                    <div class="row g-0 g-md-2 mb-3">
                                        <div class="col-md-6 col-lg-4">
                                            <label for="code" class="form-label">Code</label>
                                            <input name="redeemCode1" id="number1" type="text" class="form-control" onChange={handleChange}/>
                                        </div>
                                    </div>

                                    {uploadDocHtmlData ? uploadDocHtmlData : ""}

                                </div>
                            </div>
                        </div>
                    {!isDlTypeRef.current && 
                        <div id='multiple-code' class="row align-items-center px-md-4">
                            <div class="col-md-6 pe-md-0 d-grid col-lg-4 d-block" id="addCode" >
                                <p class="btn btn-outline-secondary redeem-btn block cb-add-code" onClick={handleAddField} >
                                    <img src="/images/add-plus.png" alt="add" class="img-fluid me-2" />
                                    Add Another Code
                                </p>
                            </div>
                            <span id="addMessage" class="c-add-row mb-3 d-none">Maximum of 20 Redemption Codes has been reached</span>

                        </div>
                    }

                        <div class="row g-0 g-md-5 mb-3 my-2 my-md-3">
                            <div class="col-md-4 d-grid cb-form-section">
                                <input type="submit" value="Continue to Shipping" class="btn btn-primary block redeem-btn" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </div>
    </>
    )
}
